import type { Plugin } from "vue";
import type { TAppConfig } from "~ui/@application/configs/config-schema.ts";

import { createI18nConfig } from "~ui/@application/configs/i18n-config.ts";

type TVoltexploitI18nConfigurationPluginOptions = {
  config: TAppConfig;
};

export const voltexploitI18nConfigurationPlugin = {
  install(app, options: TVoltexploitI18nConfigurationPluginOptions) {
    const locale = createI18nConfig(options.config);
    app.use(locale);
  },
} satisfies Plugin;
